import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { KreFormAntService } from "../tools/service";

@Component({
  selector: "kreform-group",
  template: `
    <ng-container *ngFor="let f of field.fieldGroup">
      <kreform-field [field]="f" [status]="formStatus"></kreform-field>
    </ng-container>
    <ng-content></ng-content>
  `,
  host: {
    "[class]": 'field.className || ""',
    cdkDrag: "",
  },
})
export class KreFormFieldGroup extends FieldType {}
